// extracted by mini-css-extract-plugin
module.exports = {"filterPill":"_2NxDm___FilterPill-module__filterPill","label":"hzRNS___FilterPill-module__label","close":"_280dB___FilterPill-module__close"};